import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="parameterize"
export default class extends Controller {
  static outlets = ["parameterize"];
  updateSlug() {
    if (this.hasParameterizeOutlet) {
      let parameterizedSlug = this.element.value
        .trim()
        .toLowerCase()
        .replaceAll(/[^a-zA-Z0-9\s\-_]/g, "")
        .replaceAll(/\s/g, "_");
      this.parameterizeOutletElement.value = parameterizedSlug;
    }
  }
}
